
import { Component, Prop, Vue} from "vue-property-decorator";
import Ai from "@/components/icons/fileExtensions/Ai.vue";
import Css from "@/components/icons/fileExtensions/Css.vue";
import Doc from "@/components/icons/fileExtensions/Doc.vue";
import Exe from "@/components/icons/fileExtensions/Exe.vue";
import Iso from "@/components/icons/fileExtensions/Iso.vue";
import Jpeg from "@/components/icons/fileExtensions/Jpg.vue";
import Mp4 from "@/components/icons/fileExtensions/Mp4.vue";
import Pdf from "@/components/icons/fileExtensions/Pdf.vue";
import Png from "@/components/icons/fileExtensions/Png.vue";
import Ppt from "@/components/icons/fileExtensions/Ppt.vue";
import Psd from "@/components/icons/fileExtensions/Psd.vue";
import Rtf from "@/components/icons/fileExtensions/Rtf.vue";
import Xls from "@/components/icons/fileExtensions/Xls.vue";
import UnknownExtension from "@/components/icons/fileExtensions/UnknownExtension.vue";
import AvailableExtensionsIcons from "@/entities/AvailableExtensionsIcons";
import Tooltip from "@/components/common/Tooltip.vue";

@Component({
  components: {
    Ai,
    Css,
    Doc,
    Exe,
    Iso,
    Jpeg,
    Mp4,
    Pdf,
    Png,
    Ppt,
    Psd,
    Rtf,
    Xls,
    UnknownExtension,
    Tooltip,
  }
})
export default class DocumentExtensionIcon extends Vue {
@Prop({type: String, default: undefined}) readonly extension?: string;
@Prop({type: String, default: undefined}) readonly filename?: string;
unknownExtensionComponentName: string = 'UnknownExtension';

  get extensionType(): string | undefined {
    if (!this.extension) {
      return this.unknownExtensionComponentName;
    }
    const extensionChunk = this.extension.split('/')[1];
    const extension = extensionChunk.charAt(0).toUpperCase() + extensionChunk.slice(1);
    return (Object.values(AvailableExtensionsIcons) as string[]).includes(extension)
      ? extension
      : this.unknownExtensionComponentName;
  }
}
